<template>
  <div class="wrapper">
    <div class="page__card">
      <div class="page__card-title">
        <button type="button" class="bg-indigo-400 p-1 w-8 h-8 mr-2 rounded-xl" @click="$router.push('/')">
          <i class="el-icon-arrow-left"></i>
        </button>
        <h1>{{$route.params.type=='1,2'? $t('sustainable_transport_list'): $route.params.type=='3'? $t('not_sustainable_transport_list'): $t('not_sustainable_transport4_list') }}</h1>
      </div>
    <div class="wp-body">
      <header class="wp-header">
          <div class="flex flex-wrap gap-2 flex-1">
            <div
              v-if="['admin', 'ministry', 'supervisor'].includes(role)"
              class="w-full sm:w-52"
            >
              <el-select :placeholder="$t('region')"  v-model="region" style="flex: 1; margin-right: 5px" @change="regionChanged(); __GET();" clearable>
                <el-option v-for="item in regions" :key="item.id" :label="item[`name_${$i18n.locale}`]? item[`name_${$i18n.locale}`]:item.name_cyr" :value="item.id">
                </el-option>
              </el-select>
            </div>
            <div
              v-if="['admin', 'ministry', 'supervisor'].includes(role)"
              class="w-full sm:w-52"
            >
              <el-select :placeholder="$t('district')"  v-model="district" @change="__GET()" :disabled="!region" style="flex: 1; margin-right: 5px" clearable>
                <el-option v-for="item in districts" :key="item.id" :label="item[`name_${$i18n.locale}`]? item[`name_${$i18n.locale}`]:item.name_cyr" :value="item.id">
                </el-option>
              </el-select>
            </div>
            <div class="w-full sm:w-64">
              <el-input
                class="flex-1"
                :placeholder="$t('search')"
                prefix-icon="el-icon-search"
                v-model="search_road_number"
                @keyup.enter.native="__GET()"
                clearable
              >
              </el-input>
            </div>
            <div class="flex-1"></div>
            <button
              v-if="['tf_operator'].includes(role)"
              class="add__button"
              @click="$router.push('/transport/add')"
            >
              {{ $t("add") }}
              <h-add-circle />
            </button>
          </div>
        </header>
      <el-table :data="resList.results" style="width: 99%;margin-bottom: 20px;" row-key="id">
        <el-table-column label="№" width="70" align="center">
          <template slot-scope="scope">
            {{ (current_page-1)*item_count + (scope.$index + 1) }}
          </template>
        </el-table-column>

        <el-table-column :label="$t('transport_region_name')" prop="org_name.name_cyr" align="center">
          <template slot-scope="scope">
            <router-link  :to="`/transport/${scope.row.id}`" class="router-link">{{  scope.row&&scope.row.district && scope.row.district.name_cyr?scope.row.district.name_cyr:'***'  }}  <i class="el-icon-top-right"></i> </router-link>
          </template>
        </el-table-column>
        <el-table-column :label="$t('transport_region_name_number')" prop="road_name.number" align="center">
          <template slot-scope="scope">
            <div>{{  scope.row&&scope.row.road_name && scope.row.road_name.number?scope.row.road_name.number:'***'  }}</div>
            <div class="road_name">{{  scope.row&&scope.row.road_name && scope.row.road_name.name?scope.row.road_name.name:'***'  }}</div>
          </template>
        </el-table-column>
        <el-table-column :label="$t('transport_table_facility_type')" prop="type_transport_facility.name_cyr" align="center">
        </el-table-column>
        <el-table-column :label="$t('transport_table_facility_year')" prop="year_construction" align="center">
        </el-table-column>
        <el-table-column :label="$t('transport_table_road_category')" prop="road_category.name_cyr" align="center">
        </el-table-column>
        <el-table-column prop="finalconclusion" :label="$t('finalconclusion')"  sortable >
          <template slot-scope="scope">
            <p class="finalconclusion"
              :class="`fc__bg-${scope.row.finalconclusion.id}`"
              >{{scope.row.finalconclusion.id}}  </p>
          </template>
        </el-table-column>
        <el-table-column v-if="role == 'admin'" :label="$t('passport')" width="180" align="center">
          <template slot-scope="scope">
            <div class="flex justify-center">
              <div >
                <el-button @click="GeneratePasport(scope.row.id)" class="el-icon-s-order el-button-download"></el-button>
              </div>
            </div>
          </template>
        </el-table-column>
        <el-table-column :label="$t('see')" width="100" align="center">
          <template slot-scope="scope">
            <div class="d-flex justify-center">
              <el-button size="small" @click="$router.push(`/transport/${scope.row.id}`)"  class="el-icon-view el-button-download"></el-button>
            </div>
          </template>
        </el-table-column>
        <el-table-column :label="$t('change')" width="120" align="center" v-if="['tf_operator'].includes(role)">
          <template slot-scope="scope">
            <div class="d-flex justify-center">
              <el-button :disabled="!scope.row.is_user" size="small" @click="$router.push(`/transport/edit/${scope.row.id}`)"  class="el-icon-edit el-button-download" ></el-button>
            </div>
          </template>
        </el-table-column>
      </el-table>

      <el-pagination style="margin-left: auto; margin-top: auto" class="ml-auto" :page-sizes="[10, 20, 50, 100]" :page-size="5" @current-change="paginate" @size-change="paginateSize" :current-page.sync="current_page" :hide-on-single-page="false" background layout="sizes, prev, pager, next" :page-count="page_count">
      </el-pagination>

      <el-drawer :title="$t('building_passport')" :visible.sync="drawer" direction='rtl'>
        <div>
          <div class="pdf">
            <vue-pdf ref="print" :src="pdf"></vue-pdf>
            <div class="loading-pdf" v-show="loadDawer">
              <i class="el-icon-loading"></i>
            </div>
          </div>
          <div class="w-full pdf-control">
            <button class="print" @click="downloadFile(pdf)"><i class="el-icon-download mr-2"></i> {{$t('download')}} </button>
            <a :href="pdf" target="_blank">
              <button class="ml-3 print"><i class="el-icon-view mr-2"></i> {{$t('see')}} </button>
            </a>
          </div>
        </div>
      </el-drawer>
    </div>
    </div>
  </div>
</template>

<script>
import hAddCircle from '@/components/Icons/hAddCircle.vue';
export default {
  components: {
    hAddCircle,
  },
  data() {
    return {
      pdf: '',
      namePdf: '',
      loadDawer: false,
      drawer: false,
      resList: [],
      search: '',
      page_count: 1,
      loading: false,
      userList: [],
      input2: null,
      items: [{
        message: "Foo"
      }, {
        message: "Bar"
      }],
      currentTab: 1,
      current_page: 1,
      item_count: 10,
      pdf: '',
      namePdf: '',
      loadDawer: false,
      drawer: false,
      districts: [],
      region: "",
      district: "",
      region_shared_id:'',
      search_road_number:'',
      is_invest:''
    }
  },
  computed: {
    role() {
      return this.$store.state.role;
    },
    me() {
      return this.$store.state.me;
    },
    regions() {
      return this.$store.state.dictionary.region;
    },
    building_group() {
      return this.$store.state.dictionary.buildinggroup;
    }
  },
  watch: {
    role() {
      this.current_page = this.$route.query.page || 1;
      this.__GET()
    },
  },
  mounted() {
    this.current_page = this.$route.query.page || 1;
    this.__GET()
  },
  methods: {
    regionChanged() {
      this.districts = [];
      this.district = "";
      this.getDistrict();
    },
    getDistrict() {
      this.loading = true;
      this.regions.forEach(elem => {
        if (elem.id === this.region){
          this.region_shared_id = elem.shared_id
        }
      })
      axios
          .get(`/dictionary/district/?region__shared_id=${this.region_shared_id}`)
          .then((response) => {

            this.districts = response.data;
          })
          .finally(() => {
            this.loading = false;
          });
    },
    paginate(val) {
      this.current_page = val;
      this.__GET()
    },
    paginateSize(val) {
      this.item_count = val
      this.__GET();
    },
    __GET() {
      this.loading = true;
      let offset = this.item_count * (this.current_page - 1);
      if (this.search != '' || this.region != '' || this.district != '' || this.item_count != 10) {

        this.$router.push(`/statistica/transport/${this.$route.params.type}?page=${this.current_page}&region=${this.region}&district=${this.district}&item_count=${this.item_count}&search=${this.search_road_number}`)
            .catch(e => {
              if (e.name !== 'NavigationDuplicated' && !e.message.includes('Avoided redundant navigation to current location')) {
                console.log(e)
              }
            });
        } else {
          this.$router.push(`/statistica/transport/${this.$route.params.type}?page=${this.current_page}`)
              .catch(e => {
                if (e.name !== 'NavigationDuplicated' && !e.message.includes('Avoided redundant navigation to current location')) {
                  console.log(e)
                }
              });
      }
      axios.get(`/transport_facility/?finalconclusion_id_in=${this.$route.params.type}&is_invest=${this.is_invest}&district=${this.district}&region=${this.region}&search=${this.search_road_number}&limit=${this.item_count}&offset=${offset}`)
          .then((response) => {
            this.resList = response.data;
            this.page_count = Math.ceil(response.data.count / this.item_count);
            this.current_page1 = this.$route.query.page ? this.$route.query.page : this.$route.query.page

          })
          .finally(() => {
            this.loading = false
          })
      // if (this.role == 'admin') {
      //   axios.get(`/transport_facility/?region=${this.region}&district=${this.district}&road_number=${this.search_road_number}&list=selection&limit=${this.item_count}&offset=${offset}`)
      //       .then((response) => {
      //         this.resList = response.data;
      //         console.log('this.resList1',this.resList)
      //         this.page_count = Math.ceil(response.data.count / this.item_count);
      //       })
      //       .finally(() => {
      //         this.loading = false;
      //       })
      // } else {
      //   axios.get(`/transport_facility/?road_number=${this.search_road_number}&limit=${this.item_count}&offset=${offset}`)
      //       .then((response) => {
      //         this.resList = response.data;
      //         console.log('this.resList2',this.resList)
      //         this.page_count = Math.ceil(response.data.count / this.item_count);
      //       })
      //       .finally(() => {
      //         this.loading = false;
      //       })
      // }

    },
    GeneratePasport(id) {
      this.loading = true
      axios.post(`/generate_tf/${id}/`)
          .then(res => {
            if (res.data.success) {
              this.drawer = true
              this.loadDawer = true
              this.pdf = axios.defaults.baseURL.slice(0, -8) + res.data.pdf_link
            }

          })
          .catch(e => {

          })
          .finally(() => {
            this.loading = false

            this.loadDawer = false
          })
    },
    downloadFile(file) {
      fetch(file)
          .then((resp) => resp.blob())
          .then((blob) => {
            const url = window.URL.createObjectURL(blob);
            const a = document.createElement("a");
            a.style.display = "none";
            a.href = url;
            // the filename you want
            a.download = 'Pasport' || "file.json";
            document.body.appendChild(a);
            a.click();
            window.URL.revokeObjectURL(url);
          })
    },
  }
}
</script>

<style lang="scss" scoped>
.road_name{
  display: -webkit-box;
  -webkit-line-clamp: 3;
  -webkit-box-orient: vertical;
  overflow: hidden;
  text-overflow: ellipsis;
}
.top-header {
  width: 100%;
  padding: 20px;
  box-shadow: 2px 2px 10px rgba(0, 0, 0, 0.25);
  border-radius: 5px;
  background: #fff;
  margin-bottom: 20px;
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.top-header h1 {
  font-weight: 700;
  font-size: 25px;
  color: #2f525a !important;
}
</style>
